import graphql__3d175294317b4192fc23 from "./__generated__/CustomerAccountHeader_customerAccount.graphql.ts";import * as React from "react";
import {createFragmentContainer, graphql} from "react-relay";
import ExternalServiceLinks from "./ExternalServiceLinks";

type CustomerAccountHeaderProps = {
    customerAccount: {
        id: string
        customerName: string
    }
}

const CustomerAccountHeader: React.FC<CustomerAccountHeaderProps> = ({customerAccount}) => {
    return (
        <div>
            <div className="py-4 md:flex md:items-center md:justify-between">
                <div className="flex-1 min-w-0">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                        <div className="flex items-center space-x-5">
                            <div className="shrink-0">
                                <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-red-600">
                                   <span className="text-2xl sm:text-4xl -mt-1 font-bold leading-none text-white">{customerAccount.customerName.substring(0, 1)}</span>
                                </span>
                            </div>
                            <div className="flex-1">
                                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{customerAccount.customerName}</h1>
                                <p className="text-sm font-medium text-gray-500">{customerAccount.id}</p>
                            </div>
                            <div className="shrink-0">
                                <ExternalServiceLinks identifier={customerAccount.id} type="customerAccount" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default createFragmentContainer(CustomerAccountHeader, {
        customerAccount: graphql__3d175294317b4192fc23
    }
);
